import React from "react"

const IconArrowRight = () => (
  <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.4441 6.42618L10.4441 0.426185C10.0531 0.0351846 9.42106 0.0351846 9.03006 0.426185C8.63906 0.817185 8.63906 1.44918 9.03006 1.84018L13.3231 6.13318H1.73706C1.18506 6.13318 0.737061 6.58018 0.737061 7.13318C0.737061 7.68618 1.18506 8.13318 1.73706 8.13318H13.3231L9.03006 12.4262C8.63906 12.8172 8.63906 13.4492 9.03006 13.8402C9.22506 14.0352 9.48106 14.1332 9.73706 14.1332C9.99306 14.1332 10.2491 14.0352 10.4441 13.8402L16.4441 7.84018C16.8351 7.44918 16.8351 6.81718 16.4441 6.42618Z"/>
  </svg>
  
)

export default IconArrowRight